import React from 'react';
import { Link } from 'react-router-dom';
import PaymentForm from '../../components/PaymentForm/PaymentForm';
import './Services.css';

const Services = () => {
  return (
    <div className="services">
      <section className="services-hero">
        <div className="container">
          <Link to="/" className="return-home-button">
            Return Home
          </Link>
          <div className="services-hero-copy">
            <h1>Services</h1>
            <p>Secure Payment Portal</p>
          </div>
        </div>
      </section>

      <section className="services-body">
        <div className="container">
          <PaymentForm />
        </div>
      </section>
    </div>
  );
};

export default Services;

